import gql from 'graphql-tag'

/**
 * Query
 */
const ALL_ACTIVE = gql`
    query mediumHeavyActive {
        mediumHeavyActive {
            id
            heavy
            piece
            rate
            is_active
            status_text
        }
    }
`
const GET_WITH_PAGINATION = gql`
    query mediumHeavyWithPagination ($page: Int, $perPage: Int) {
        mediumHeavyWithPagination (page: $page, first: $perPage) {
            paginatorInfo {
                currentPage
                count
                hasMorePages
                perPage
                total
            }
            data {
                id
                heavy
                piece
                rate
                is_active
                status_text
            }
        }
    }
`
/**
 * Mutations
 */
 const CREATE = gql`
    mutation createMediumHeavy ($input: CreateMediumHeavyInput!) {
        createMediumHeavy (input: $input) {
            id
            heavy
            piece
            rate
            is_active
            status_text
        }
    }
`

const UPDATE = gql`
 mutation updateMediumHeavy ($id: ID!, $input: UpdateMediumHeavyInput!) {
    updateMediumHeavy (id: $id, input: $input) {
        id
        heavy
        piece
        rate
        is_active
        status_text
     }
 }
`

const CHANGE_STATUS = gql`
 mutation updateMediumHeavy ($id: ID!, $input: UpdateMediumHeavyInput!) {
    updateMediumHeavy (id: $id, input: $input) {
        id
        heavy
        piece
        rate
        is_active
        status_text
     }
 }
`

const DELETE = gql`
 mutation deleteMediumHeavy ($id: ID!) {
    deleteMediumHeavy (id: $id) {
        id
        heavy
        piece
        rate
        is_active
        status_text
     }
 }
`

export {
    ALL_ACTIVE,
    GET_WITH_PAGINATION,
    CREATE,
    UPDATE,
    CHANGE_STATUS,
    DELETE
}
